import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatModule } from 'src/app/appModules/mat.module';
interface Seller {
  id: string;
  name: string;
  email: string;
  isActive: boolean;
}

@Component({
  selector: 'app-user-list',
  imports: [MatPaginator, MatSort, MatCardModule, MatFormFieldModule, MatTableModule, MatInputModule, MatModule],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent {
  displayedColumns: string[] = ['id', 'name', 'email', 'isActive', 'actions'];
  dataSource = new MatTableDataSource<Seller>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  sellers: Seller[] = [
    { id: '1', name: 'John Doe', email: 'john@example.com', isActive: true },
    { id: '2', name: 'Jane Smith', email: 'jane@example.com', isActive: false }
  ];

  ngOnInit(): void {
    this.dataSource.data = this.sellers;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  toggleStatus(seller: Seller): void {
    seller.isActive = !seller.isActive;
  }

  editSeller(seller: Seller): void {
    console.log('Editing:', seller);
  }

  deleteSeller(id: string): void {
    this.sellers = this.sellers.filter(seller => seller.id !== id);
    this.dataSource.data = this.sellers;
  }
}

interface Seller {
  id: string;
  name: string;
  email: string;
  isActive: boolean;
}